"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../hooks");
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const no_case_1 = tslib_1.__importDefault(require("no-case"));
exports.FeatureDemoFeaturesList = () => {
    const { features, state: { usecase, persona }, } = hooks_1.useFeatureDemoContext();
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "my-5" },
        react_1.default.createElement(react_loops_1.For, { of: features, ifEmpty: react_1.default.createElement(react_2.OsmosysUndesiredState, { message: `No features found for ${no_case_1.default(usecase)} usecase for the ${no_case_1.default(persona)} persona` }) }, feature => {
            return react_1.default.createElement(exports.FeatureDemoFeature, Object.assign({}, feature));
        })));
};
exports.FeatureDemoFeature = ({ name, images, status, description, personas, }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "card p-3 mb-2", flexColFilled: true },
        react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { className: "mb-2" },
                    react_1.default.createElement("h4", null, name),
                    react_1.default.createElement("p", { className: "lead mb-1" }, description),
                    react_1.default.createElement(react_loops_1.For, { of: personas }, persona => {
                        return (react_1.default.createElement(reactstrap_1.Badge, { className: "mr-1", color: "dark" },
                            react_1.default.createElement(react_2.OsmosysChangeCase, { type: "sentenceCase" }, persona)));
                    }))),
            react_1.default.createElement(react_2.OsmosysDiv, null,
                react_1.default.createElement(reactstrap_1.Button, { color: "link", disabled: true, className: status === 'production'
                        ? 'text-success'
                        : status === 'experimental'
                            ? 'text-warning'
                            : 'text-muted' },
                    react_1.default.createElement(react_2.OsmosysChangeCase, { type: "sentenceCase" }, status),
                    ' ',
                    "feature"))),
        react_1.default.createElement(react_loops_1.For, { of: images }, (image, { isLast }) => (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
            react_1.default.createElement("img", { className: react_2.classnames('border rounded mx-auto ', !isLast && 'mb-2'), style: { maxWidth: 700 }, src: image }))))));
};
//# sourceMappingURL=index.js.map